import { useContext } from 'react';
import { usePostRequest } from '../../core/coreUseRequest';
import { store } from '../store';

/** useCreateCharge ::  {} */
export default function useUpdateOrgInfo() {
	const { dispatch } = useContext(store);
	const mutation = usePostRequest({
		url: '/account/org/update/info',
		queryName: 'updateOrgInfo',
		dispatch,
		successFn: (successMsg, { values, formFns }) => {
			const { reset } = formFns;
			reset(values);
			/**
			 * If you would like to reset the form values here set up the mutate fn
			 * from FordCardRHF like so:
			 * FormCardRHF::onSubmit={(values, formFns) => mutate(values, formFns)}
			 */
		}
	});

	return mutation;
}
